import { render, staticRenderFns } from "./CrmFunnels.vue?vue&type=template&id=20fa4a12&scoped=true&"
import script from "./CrmFunnels.vue?vue&type=script&lang=js&"
export * from "./CrmFunnels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa4a12",
  null
  
)

export default component.exports